// extracted by mini-css-extract-plugin
export default {"logo":"CompanyLogo_logo__BRodx"};